module.exports = __webpack_public_path__ + "img/card2.6e83af69.svg";